import React, { useState, useEffect, Fragment } from 'react'
import { Col, Container, Row } from "react-bootstrap";
import Sidebar from "../../Components/Sidebar";
import Header from "../../Components/Header";
import ReactDatatable from "@ashvin27/react-datatable";
import { toastAlert } from "../../lib/toastAlert";
import config from "../../lib/config"
import moment from 'moment';
import { useNavigate, useParams } from 'react-router-dom';
import Exportexcel from "../pdf/Excelexport"
import Exportpdf from "../pdf/Exportpdf"
import Exportcsv from "../pdf/Exportcsv"
import { CollectionGetOwn, CollectionSingleMaySent, HideCollectionSingle, updateCollectionStatusSingle } from '../../actions/users';

const ViewCollection = () => {

    const navigate = useNavigate()
    const [userdet, setUser] = useState();
    const [exportdata, setExportdata] = useState([]);
    const [responsive, setresponsive] = useState(true);
    const [allcheck, setAllcheck] = useState(false);
    const { Owner, Id } = useParams();

    useEffect(() => {
        getTokenData();
    }, []);

    const getTokenData = async () => {
        var reqdata = {
            CollectionName: Id,
            Address: Owner,
        };
        var test = await CollectionGetOwn(reqdata);
        if (test.userValue.Success) {
            setUser(test.userValue.userValue);
            var ddd = test.userValue.userValue.map(({ _id, tokenOwnerDb, ...rest }) => {
                return rest
            })
            setExportdata(ddd)
        }
        else {

        }
    };

    const Enlarge = (e) => {
        if (Number(e.target.naturalWidth) > 700 || Number(e.target.naturalHeight) > 700) {
            e.target.width = String(Number(e.target.naturalWidth) / 4)
            e.target.height = String(Number(e.target.naturalHeight) / 4)
        }
        else {
            e.target.width = String(Number(e.target.naturalWidth) / 2)
            e.target.height = String(Number(e.target.naturalHeight) / 2)
        }
    }
    const VEnlarge = (e) => {
        if (Number(e.target.videoWidth) > 700 || Number(e.target.videoHeight) > 700) {
            e.target.width = String(Number(e.target.videoWidth) / 4)
            e.target.height = String(Number(e.target.videoHeight) / 4)
        }
        else {
            e.target.width = String(Number(e.target.videoWidth) / 2)
            e.target.height = String(Number(e.target.videoHeight) / 2)
        }
    }

    const Reset = (e) => {
        e.target.width = "25"
        e.target.height = "25"
    }

    function pageChange(pageData) {
    }

    const handleChangemaysent = async (event) => {
        let { id, checked } = event.target;
        let handlemaychange = await updateCollectionStatusSingle({ email: id, maySentChecked: checked });
        if (handlemaychange.Success) {
            toastAlert("success", 'Selected');

            getTokenData()

        }
        else {
            toastAlert("error", 'Error on Server');
        }
    }

    const setMaySent = async (data) => {
        if (data?.target) {
            if (userdet.length > 0) {

                var resp = await CollectionSingleMaySent({ all: data.target.checked });
                if (resp?.Success) {
                    setAllcheck(!allcheck)
                    toastAlert("success", 'Success...Please wait for data refresh');
                    getTokenData()
                }
                else
                    toastAlert("error", resp.Message)
            } else {
                toastAlert("error", "Subscribers are not yet")
            }
        } else {
            var payload = {
                email: data.email,
                maySent: !data.maySent
            }

            var resp = await CollectionSingleMaySent(payload);
            if (resp?.Success) {
                toastAlert("success", 'Success...Please wait for data refresh');
                getTokenData()
            }
            else
                toastAlert("error", resp.msg)
        }

    }

    const deleteUser = async () => {
        var send = {
            Show: "Hide"
        }
        let handlemaychange = await HideCollectionSingle(send);
        if (handlemaychange.Success) {
            toastAlert("success", 'Collection Hide Succesfully');
            getTokenData()
        }
        else {
            toastAlert("error", 'Error on Server');
        }
    }

    const Show = async () => {
        var send = {
            Show: "Show"
        }
        let handlemaychange = await HideCollectionSingle(send);
        if (handlemaychange.Success) {
            toastAlert("success", 'Collection is Visible Now');
            getTokenData()
        }
        else {
            toastAlert("error", 'Error on Server');
        }
    }

    const columns = [
        {
            key: "action",
            text: "Action",
            className: "action",
            width: 100,
            align: "left",
            sortable: false,
            cell: record => {
                return (
                    <div className='text-center exchange_table_values'>
                        {record && <input type="checkbox" name={record.tokenID} id={record.tokenID} checked={record.MayChecked} onChange={(event) => { handleChangemaysent(event) }} />}
                    </div>
                );
            }
        },
        {
            key: "ind",
            text: "SNO",
            className: "name",
            align: "left",
            sortable: true,
            cell: (row, index, column, id) =>
                <p className='text-center exchange_table_values'>{index + 1}</p>

        },
        {

            key: "tokenID",
            text: "Token Count",
            className: "tokenId",
            align: "left",
            sortable: false,
            cell: (val) =>
                <p className='text-center exchange_table_values'>{val.tokenID}</p>
        },
        {

            key: "additionalImage",
            text: "NFT Token Preview",
            className: "tokenOwner",
            align: "left",
            sortable: false,
            cell: record =>
                <div className='text-center exchange_table_values'>
                    {record.image &&
                        (record.image.split(".").pop() !== "mp4") ? (
                        <img
                            onMouseOver={(e) => Enlarge(e)}
                            onMouseLeave={(e) => Reset(e)}
                            width="25"
                            height="25"
                            src={`${config.Back_Url}/nftImg/${record.tokenCreator}/${record.additionalImage}`}
                        />
                    )
                        :
                        (
                            <video
                                onMouseOver={(e) => VEnlarge(e)}
                                onMouseLeave={(e) => Reset(e)}
                                width="25"
                                height="25"
                                autoPlay
                                muted
                                loop
                                type="video/mp4"
                                src={`${config.Back_Url}/imfImg/${record.tokenCreator}/${record.additionalImage}`}
                            />
                        )}
                </div>
        },
        {
            key: "tokenName",
            text: "Token Name",
            className: "Name",
            align: "left",
            sortable: false,
            cell: (val) =>
                <p className='text-center exchange_table_values'>{val.tokenName}</p>
        },
        {

            key: "tokenCreator",
            text: "Token Creator",
            className: "tokenCreator",
            align: "left",
            sortable: false,
            cell: (val) =>
                <p className='text-center exchange_table_values'>{val.tokenCreator}</p>
        }, {

            key: "tokenOwner",
            text: "Token Owner",
            className: "tokenOwner",
            align: "left",
            sortable: false,
            cell: val =>
                <div className='text-center exchange_table_values'>{String(val.tokenOwnerDb.tokenOwner)}</div>


        },
        {

            key: "tokenCategory",
            text: "Token Category",
            className: "tokenCategory",
            align: "left",
            sortable: false,
            cell: (val) =>
                <p className='text-center exchange_table_values'>{val.tokenCategory}</p>
        },
        {

            key: "tokenRoyality",
            text: "Token Royality (in Percentage)",
            className: "tokenRoyality",
            align: "left",
            sortable: false,
            cell: (val) =>
                <p className='text-center exchange_table_values'>{val.tokenRoyality}</p>
        },
        {

            key: "tokenBid",
            text: "Token Bid",
            className: "tokenBid",
            align: "left",
            sortable: false,
            cell: val =>
                <div className='text-center exchange_table_values'>{(val.tokenBid).toString()}</div>

        },
        {

            key: "tokenQuantity",
            text: "Token Quantity",
            className: "tokenQuantity",
            align: "left",
            sortable: false,
            cell: val =>
                <div className='text-center exchange_table_values'>{val.tokenQuantity}</div>
        },
        {

            key: "balance",
            text: "Token Available Quantity(balance)",
            className: "balance",
            align: "left",
            sortable: false,
            cell: val =>
                <div className='text-center exchange_table_values'>{String(val.tokenOwnerDb.balance)}</div>


        },

        {

            key: "tokenPrice",
            text: "Token Price",
            className: "tokenPrice",
            align: "left",
            sortable: false,
            cell: val => <div className='text-center exchange_table_values'>
                {val.tokenOwnerDb.tokenPrice &&
                    <div>{String(val.tokenOwnerDb.tokenPrice)} {String(val.tokenOwnerDb.coinname)}</div>
                }
            </div>
        },

        {

            key: "status",
            text: "Token Status",
            className: "status",
            align: "left",
            sortable: false,
            cell: (val) =>
                <p className='text-center exchange_table_values'>{val.status}</p>
        },
        {

            key: "ipfsimage",
            text: "Image Hash Value",
            className: "image",
            align: "left",
            sortable: false,
            cell: record =>
                <div className='text-center exchange_table_values'><p>{(config.IPFS_IMG + "/" + record.ipfsimage)}</p></div>


        },
        {
            key: "timestamp",
            text: "Created At",
            className: "Date",
            align: "left",
            sortable: false,
            cell: record =>
                <div className='text-center exchange_table_values'><p>{moment(record.timestamp).format('MMMM,Do YYYY, hh:mm A')}</p></div>
        },
        {
            key: "deleted",
            text: "Hide/Show",
            className: "Date",
            align: "left",
            sortable: false,
            cell: record =>
                <div className='text-center exchange_table_values'><p>{(record.deleted == 1) ? "Visible" : "Hidden"}</p></div>
        },
    ];

    const configdata = {
        page_size: 5,
        length_menu: [10, 20, 50],
        filename: "Users",
        no_data_text: "No user found!",

        language: {
            length_menu: "Show _MENU_ result per page",
            filter: "Filter in records...",
            info: "Showing _START_ to _END_ of _TOTAL_ records",
            pagination: {
                first: "First",
                previous: <> Previous </>,
                next: <>Next</>,
                last: "Last",
            },
        },
        show_length_menu: true,
        show_filter: true,
        show_pagination: true,
        show_info: true,
        defaultSortAsc: true,
    };

    return (
        <>
            <Container fluid className="common_bg position-relative">
                <div className="liner"></div>
                <Row>
                    <Col xl={2} lg={0} className='p-0 d-none d-xl-block'>
                        <Sidebar />
                    </Col>
                    <Col xl={10} lg={12}>
                        <Header title={'Token List'} />

                        <div className="common_page_scroller mt-5 pe-2">
                        <div>
                              <button className='btn addcate' onClick={()=>navigate(-1)}>Back</button>
                            </div>

                            <div className="page_header">
                                <h2>Category List</h2>

                                <div>
                                <div className="selection_sec">
                                    <div className="checkbox_sec_user">
                                        <span>SELECT ALL</span>
                                        <input type="checkbox" className='selectall ms-2' checked={allcheck} onChange={(e) => setMaySent(e)} />
                                    </div>
                                    <div>
                                        <button className="ms-3" variant="contained" onClick={() => deleteUser()} color="primary">Hide NFTs</button>
                                    </div>
                                    <div>
                                        <button className="ms-3" variant="contained" onClick={() => Show()} color="primary">Show NFTs</button>
                                    </div>
                                    </div>
                                </div>

                            </div>
                            <div className="exchange_table_holder dashboard_box rounded-3 mt-4">
                                <ReactDatatable
                                    className="table table-striped table-bordered table-responsive"

                                    responsive={responsive}
                                    config={configdata}
                                    records={userdet}
                                    columns={columns}
                                    onPageChange={pageChange()}
                                />
                            </div>
                        </div>
                        <div className='bottom_btn_comp'>
                            <Exportexcel excelData={exportdata} fileName={'category'} />
                            <Exportpdf pdfData={exportdata} fileName={'category'} />
                            <Exportcsv csvData={exportdata} fileName={'category'} />
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default ViewCollection